import type { FC } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { unmask } from '@packages/gql/src/betterMasking';
import type { TopCategoriesFragmentFragmentDoc } from '@packages/gql/generated/shopping/TopCategoriesFragmentFragmentDoc';

import { TopCategoryItem } from '../TopCategoryItem/TopCategoryItem';

const messages = defineMessages({
  headline: {
    id: 'search.topCategories.headline',
    defaultMessage: 'Stöbere in unseren Kategorien',
  },
});

/* GraphQL */ `
  fragment TopCategoriesFragment on TopCategory {
    id
    ...TopCategoryItemFragment
  }
`;

export type TopCategoriesProps = {
  /** The top categories to display */
  maskedTopCategories: Array<FragmentType<typeof TopCategoriesFragmentFragmentDoc>>;
};

/**
 * TopCategories component displays a grid of top categories to browse in case of no search results.
 * */
export const TopCategories: FC<TopCategoriesProps> = ({ maskedTopCategories }) => {
  const topCategories = unmask<typeof TopCategoriesFragmentFragmentDoc>(maskedTopCategories);

  return (
    <>
      <h5>
        <FormattedMessage key="topcategories.headline" {...messages.headline} />
      </h5>
      <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-6 lg:grid-cols-8">
        {topCategories.map((topCategory) => (
          <div key={topCategory.id}>
            <TopCategoryItem maskedTopCategory={topCategory} />
          </div>
        ))}
      </div>
    </>
  );
};
